/**
 * 英语
 */
export default {
  customProduct: {
    CustomProduct: 'Custom Product',
    Status: 'Status',
    SampleFee: 'Sample Fee',
    inputPlaceholder: 'search by product name or demand no.',
    AddNewDemand: 'Add New Demand',
    Product: 'Product',
    AddedTime: 'Added Time',
    DemandStatus: 'Demand Status',
    PaymentStatus: 'Payment Status',
    Action: 'Action',
    Details: 'Details',
    DemandNo: 'Demand No',
    More: 'More',
    Edit: 'Edit',
    PaySampleFee: 'Pay Sample Fee',
    PayNow: 'Pay Now',
    PaymentRecords: 'Payment Records',
    Cancel: 'Cancel',
    Unreceived: 'Unreceived',
    Received: 'Received',
    Completed: 'Completed',
    Canceled: 'Canceled',
    Published: 'Published',
    Unpaid: 'Unpaid',
    Paid: 'Paid',
    CreatedTime: 'Created Time',
    TransactionTime: 'Transaction Time',
    Amount: 'Amount',
    PaySampleFeeTips: 'Please pay the sample fee，sample order can be generated after payment',
    PaymentAmount: 'Payment Amount',
    PaymentMethod: 'Payment Method',
    CreditCard: 'Credit Card',
    Balance: 'Balance',
    Confirm: 'Confirm',
    transactionError: 'Generate transaction order exception',
    CustomProcess: 'Custom Process',
    stepTitle1: 'Submit your custom requirements',
    stepDescription1_1: 'Click the',
    stepDescription1_2: 'button, fill in the information of the products you need to customize.',
    stepTitle2: 'Get in touch with our customer service representative',
    stepDescription2: 'Our customer service representative will send you a contact email to communicate your custom requirements with you.',
    stepTitle3: 'Payment and delivery of samples',
    stepDescription3: 'The customer pays the proofing fee and Kakaclo will mail the sample to the customer for confirmation.',
    stepTitle4: 'Confirmation of samples and formal production',
    stepDescription4: 'Once the sample is confirmed, you can contact our customer service representative to start formal production.',
    Remark: 'Remark',
    TotalAmount: 'Total Amount'
  },
  customDetail: {
    Back: 'Back',
    AddNewDemand: 'Add New Demand',
    Style: 'Style',
    ProductName: 'Product Name',
    ProductNamePlace: 'T-shirt,skirt,jacket,etc',
    ContactEmail: 'Contact email',
    ContactEmailPlace: 'Enter a valid email number',
    PhoneNumber: 'Phone Number',
    EstimatedOrderQuantity: 'Estimated Order Quantity',
    EstimatedOrderQuantityPlace: 'Number of products ordered',
    ColorQuantity: 'Color Quantity',
    ColorQuantityPlace: 'How many color you want to custom?',
    SizeQuantity: 'Size Quantity(per color)',
    SizeQuantityPlace: 'How many size you want to custom?',
    ReferenceLinking: 'Reference Linking',
    ReferenceLinkingTooltip: 'The link of the product you want to custom.',
    ReferenceLinkingPlace: 'Enter the Link address',
    Description: 'Description',
    DescriptionPlace: 'Tell us about the details of the product you want to custom.',
    Image: 'Image',
    ImageTip: '(Image may only be up to 10.)',
    Fabric: 'Fabric',
    Category: 'Category',
    FabricName: 'Fabric Name',
    CategoryPlace: 'linen,cotton,etc',
    Weight: 'Weight(g)',
    WeightPlace: 'The weight of the fabric',
    Composition: 'Composition',
    Add: 'Add',
    Accessories: 'Accessories',
    Printing: 'Printing',
    PrintingType: 'Printing Type',
    PrintingTypePlace: 'Pigment print,etc',
    ReferenceLinkingPlace2: 'The reference link of the pattern',
    Width: 'Width(cm)',
    WidthPlace: 'The width of the patten',
    Length: 'Length(cm)',
    LengthPlace: 'The length of the patten',
    Position: 'Position',
    PositionPlace: 'The print position on the clothes',
    Description2: 'The description of the pattern',
    Embroidery: 'Embroidery',
    PrintingType2: 'Appliqu,embroidered patches,etc',
    Color: 'Color',
    Washing: 'Washing',
    WashingType: 'Washing Type',
    WashingTypePlace: 'Stone wash,enzyme wash,etc',
    PositionPlace2: 'Which location needs cleaning？',
    OtherTechnology: 'Other Technology',
    TechnologyName: 'Technology Name',
    Submit: 'Submit',
    InputContent: 'Input content',
    edit: 'edit',
    detail: 'detail',
    onlyPictures: 'Only pictures can be uploaded',
    pictureSize: 'The maximum image support is 5M，Format support：jpg、png、gif'
  },
  touristCustom: {
    SubmittedSuccessfully: 'Submitted Successfully',
    tip1: 'Thanks for your submission.',
    tip2: 'Our support team will follow up and get back to you as soon as possible.',
    back: 'back',
    CustomProduct: 'Custom Product',
    AddedTime: 'Added Time',
    DemandNo: 'Demand No.',
    Home: 'Home'
  }
}
